import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import FileUploadMultiple, { File } from 'components/FileUploadMultiple';
import MasterPage from 'components/MasterPage';
import Comprovations from './Comprovations';
import PadLock from 'components/PadLock';
import arrayAppend from 'helpers/array-append';
import { parseDateBR } from 'helpers/date';
import { api } from 'services';
import { ASYNC_CREATE_COMPROVATION } from 'store';
import Dialog from 'react-bootstrap-dialog';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useHistory } from 'react-router-dom';

const DashboardCreativeForm = ({
  saveComprovationCreative,
  match: {
    params: { id }
  },
  loading
}) => {

  var dialog;

  const history = useHistory();

  const { t } = useTranslation();

  const [data, setData] = useState([]);
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [actionId, setActionId] = useState('');
  const [task, setTask] = useState('');
  const [description, setDescription] = useState('');
  const [comprovations, setComprovations] = useState([]);
  const [amount, setAmountTasks] = useState('');
  const [theme, setTheme] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [observation, setObservation] = useState('');
  const [files, setFiles] = useState([]);
  const [filesComments, setFilesComments] = useState([]);
  const [filesBriefing, setFilesBriefing] = useState([]);
  
  const [user, setUser] = useState('');
  const [defaultUser, setDefaultUser] = useState('');
  const [userList, setUserList] = useState([]);
  
  const [others, setOthers] = useState({});

  const [moreFields, setMoreFields] = useState({});
  
  const [isEditable, setEditable] = useState(false);
  const [load, setLoad] = useState(true);
  const [requester, setRequester] = useState("");
  const [itemBriefing, setItemBriefing] = useState([])
  
  useEffect(() => {
    api.get(`action-task/${id}`).then(({ data }) => {
      setData(data);
      setItemBriefing(data.briefing)
      setEditable(data.is_editable);
      setOthers(data.others_object);
      setActionId(data.action_id);
      setName(data.action.name);
      setCompany(data.action.company.alias);
      setTask(data.task.name);
      setAmountTasks(data.action.amount_tasks);
      setDescription(data.action.description);
      setComprovations(data.action_comprovations);
      setTheme(data.description);
      setDeliveryDate(data.delivery_date);
      setFilesBriefing(data.action.files_briefing);
      setUser(data.user_id?data.user_id.toString():'');
      setDefaultUser(data.user_id?data.user_id.toString():'');
      setLoad(false);
      setRequester(getRequesterName(data.action.company.users[0]));
      data.action_comprovations.forEach(a => {
        if(a.status_id == 18){
          let data = a.date_at.split(' ')[0];
          setMoreFields({
            link:a.link,
            date_at:new Date(new Date(data).setDate(new Date(data).getDate()+1))
          });
        }
      });
    });

    api.get(`by-profile/8`).then(({ data }) => {
      setUserList(data.map(user=>{
        return {label:(user.firstname+' '+user.lastname).toUpperCase(), value:user.id};
      }))

    });

  }, [id]);

  const getRequesterName = ({ firstname, lastname }) => {
    return `${firstname} ${lastname}`;
  }

  const handleApprove = async (e,status) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('status_id', status);
    formData.append('action_id', actionId);
    formData.append('action_task_item_id', id);
    if(status != 27) {
      formData.append('observation', observation);
      formData.append('has_observation', 1);
      arrayAppend(formData, 'file', files);
      arrayAppend(formData, 'files_comments', filesComments);
    }

    saveComprovationCreative(formData);
  };

  const handleExecute = (e) => {
    const formatDate = date => {
      var d = new Date(date),
        month = '' + (d.getUTCMonth() + 1),
        day = '' + d.getUTCDate(),
        year = d.getUTCFullYear();
    
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
    
      return [year, month, day].join('-');
    };
    e.preventDefault();
    var id = '';
    //let list = comprovations.filter(a=>a.status_id===12);
    let list = comprovations.filter(a=>a.status_id===27);
    if(list.length>0) id = list[0].id;

    if(id){
      api.put(`execute-action-comprovation/${id}`, {
        ...moreFields, 
        status_id:18,
        date_at:formatDate(moreFields.date_at)
      }).then(({ data }) => {
        //setDefaultUser(data?data.toString():'');
        window.location.href = window.location.href;
      });
    }
  };

  const handleRecuse = async (e, comment) => {
    let headers = {
      'X-Redirect': '/creative',
      'X-Show-Alert': true
    }

    let formData = new FormData()
    formData.append("_method", "put")
    formData.append('action_id', actionId);
    formData.append('action_task_item_id', id);
    formData.append('comments_approval', comment);

    if (comprovations.length > 0) {
      let [item] = comprovations
      formData.append('status_id', 11);
      headers['X-Success-Message'] = 'Item recusado'
      api.post('action-comprovations/'+item.id, formData, { headers }).then();
    } else {      
      formData.append('status_id', 26);
      headers['X-Success-Message'] = 'Briefing recusado'
      api.post(`briefing-refuse`, formData, { headers }).then(({ data }) => {
        setEditable(true);
      });
    }

    
  };

  const salvarUser = async e => {
    e.preventDefault();
    //save-user-action-task-item
    api.put(`save-user-action-task-item/${id}`,{params:{user:user}}).then(({ data }) => {
      setDefaultUser(data?data.toString():'');
    });
  };

  const disabled = () => {
    let isDisable = false;
    comprovations.map(comprovation => {
      if (comprovation.status_id == 10 || comprovation.status_id === 12 || comprovation.status_id === 27)
        isDisable = true;
    });
    return isDisable;
  };

  const disabledSaveUser = () => {
    let disable;
    comprovations.map(comprovation => {
      if (comprovation.status_id === 12) {
        disable = true;
      }
      if (comprovation.status_id === 18) {
        disable = true;
      }
    });
    return disable;
  };

  const getOthersProperties = () => {
    return (
      <>
      {Object.keys(others).map(k=>{
        return(
        <Col>
          <Form.Group>
            <Form.Label>{t('label:'+k)}</Form.Label>
            <Form.Control
              placeholder="Insira aqui"
              value={others[k]}
              required
              disabled={true}
            />
          </Form.Group>
        </Col>
        );
      })}
      </>
    );
  };

  const confirmation = (e) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    var comment = '';

    dialog.show({
      body: (<>
        {t('phrase:are you sure?')}
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>Motivo da recusa?</Form.Label>
              <Form.Control
                as="textarea"
                onChange={e=>comment = e.target.value}
                rows="4"
              />
            </Form.Group>
          </Col>
        </Row>
        </>),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          handleRecuse(e, comment);
        }),
      ],
      bgSize: 'small',
    });
  };

  const isApproved = () => {
    return comprovations.filter(a=>a.status_id===12).length > 0; 
  };

  const isFinished= () => {
    return comprovations.filter(a=>a.status_id===18).length > 0; 
  };

  const isApprovedBroadcasting = () => {
    return comprovations.filter(a => a.status_id == 27).length > 0;
  }

  const renderReleaseToUpdateBtn = () => {
    if (!isEditable)
      return (
        <Button>
          Liberar Item
        </Button>
      )
  }

  const renderSendArtsApprovationBtn = () => {
    if (comprovations.length == 0) {
      if (!isEditable && data.enabled_send_arts) {
        return (
          <Button
            size="sm"
            variant="dark"
            className="ml-2"
            onClick={(e)=>handleApprove(e,10)}
            //disabled={disabled() && !isEditable}
          >
            {t('flow:arts_approval')}
          </Button>
        )
      } else {
        return (<>
          {data.action.status_id !== 26 && data.material_complete == 1 ? (
            <Button
              size="sm"
              variant="dark"
              className="ml-2"
              onClick={(e)=> {
                api.put('enable-editable-action-task-item/'+id, {}, {
                  headers: {
                    'X-Success-Message': 'Habilitado pra subir artes',
                    'X-Redirect': '/creative',
                    'X-Show-Alert': true
                  }
                })
                  //.then(() => history.goBack())
              }}
              //disabled={disabled() && !isEditable}
            >
              {'Habilitar Inserção de Arte'}
            </Button>
          ) : (<></>)}
        </>)
      }
    }
    
  }

  const renderRefuseBtn = () => {
    if (
      data.material_complete == 1 && comprovations.length == 0 || 
      comprovations.filter(a => a.status_id == 12 || a.status_id == 27).length > 0
    ) {
      return (
        <Button
          size="sm"
          variant="dark"
          className="ml-2"
          onClick={confirmation}
        >
          {comprovations.length > 0 ? 'Recusar' : 'Recusar Briefing'}
        </Button>
      )
    }
  }

  const renderApprovedBroadcastingBtn = () => {
    if (isApproved()) {
      return (
        <Button
          size="sm"
          variant="dark"
          className="ml-2"
          onClick={e => {
            //handleApprove(e,27)
            let [item] = comprovations.filter(a=>a.status_id === 12);

            let formData = new FormData()
            formData.append("_method", "put");
            formData.append('status_id', 27)
            formData.append('action_id', item.action_id)
            formData.append('action_task_item_id', item.action_task_item_id)

            api.post('action-comprovations/'+item.id, formData)
              .then(() => history.goBack());
          }}
        >
          {'Aprovar pra Veiculação'}
        </Button>
      )
    }
  }

  const getMoreFields = () => {
    const getValue=(n)=>{
      return moreFields[n]?moreFields[n]:'';
    }

    const setValue=(n,v)=>{
      let fields_aux = {...moreFields};
      fields_aux[n] = v;
      setMoreFields({...fields_aux});
    }

    const getLink=()=>{
      let link = getValue('link');
      var link_aux = '';
      if(link.indexOf('http') === -1)
        link_aux += 'http://';
      if(link.indexOf('www') === -1)
        link_aux += 'www.';
      return link_aux+link;
    }
    //let show = isApproved() || isFinished();
    let show = isApprovedBroadcasting() || isFinished()
    if(show){
      return (<>
        <Col md="6">
          <Form.Group>
            <Form.Label>Link</Form.Label>
            <Form.Control
              as="input"
              value={getValue('link')}
              onChange={(e)=>setValue('link',e.target.value)}
              disabled={isFinished()}
            />
            <Form.Text className="text-muted">
              <a href={getLink()} target="_blank">{getValue('link')}</a>
            </Form.Text>
          </Form.Group>
        </Col>
        <Col md="auto">
          <Form.Group>
            <Form.Label>Data</Form.Label>
            <DatePicker
              className="form-control"
              dateFormat="dd/MM/yyyy"
              locale="pt_BR"
              selected={getValue('date_at')}
              onChange={(date) => setValue('date_at',date)}
              disabled={isFinished()}
              //placeholderText={t('label:insert here')}
            />
          </Form.Group>
        </Col>
      </>);
    }
    return <></>;
  };

  return (
    <>
      <Dialog
        ref={(component) => {
          dialog = component;
        }}
      />
      <Row className="mt-2">
        <Col sm={12} className=" mb-3">
          <Button onClick={() => history.goBack() }>Voltar</Button>
        </Col>
        <Col>
          <Card.Body className="shadow bg-white rounded mb-3">
            <PadLock />
            <Row className="text-right"></Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>{t('label:action id')}</Form.Label>
                  <Form.Control value={actionId} disabled />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:action name')}</Form.Label>
                  <Form.Control value={name} disabled />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:company')}</Form.Label>
                  <Form.Control value={company} disabled />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:activity')}</Form.Label>
                  <Form.Control value={task} disabled />
                </Form.Group>
              </Col>

              <Col xs={4} md={4}>
                <Form.Group>
                  <Form.Label>{t('label:requester name')}</Form.Label>
                  <Form.Control value={requester} disabled />
                </Form.Group>
              </Col>

              <Col xs={2} md={2}>
                <Form.Group>
                  <Form.Label>{t('label:quantity')}</Form.Label>
                  <Form.Control disabled value={amount} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:description')}</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={description}
                    disabled
                    rows="4"
                  />
                </Form.Group>
              </Col>
            </Row>

            {itemBriefing.length > 0 ? (
              <Row className="align-content-start mt-1 mb-3">
                <Col xs="12">
                  <hr />
                  <h6>Briefing</h6>
                </Col>
                <Col className="auto">
                  <Row>
                    {itemBriefing.map((file, k) => (
                      <Col md="1" key={k} className="d-flex flex-column">
                        <File
                          extension={file.extension}
                          comment={file.comment}
                          uri={file.uri}
                        />
                        <span>{file.name}</span>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            ) : (<></>)}

            {filesBriefing.length > 0 ? (
              <Row className="align-content-start mt-1 mb-3">
                <Col xs="12">
                  <hr />
                  <h6>Briefing da Ação</h6>
                </Col>
                <Col className="auto">
                  <Row>
                    {filesBriefing.map((file, k) => (
                      <Col md="1" key={k} className="d-flex flex-column">
                        <File
                          extension={file.extension}
                          comment={file.comment}
                          uri={file.uri}
                        />
                        <span>{file.name}</span>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            ) : (<></>)}
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:theme')}</Form.Label>
                  <Form.Control value={theme} disabled />
                </Form.Group>
              </Col>
              <Col xs={2} md={2}>
                <Form.Group>
                  <Form.Label>{t('label:delivery date')}</Form.Label>
                  <Form.Control value={parseDateBR(deliveryDate)} disabled />
                </Form.Group>
              </Col>
              {getOthersProperties()}
              <Col xs={4} md={4}>
                <Form.Group>
                  <Form.Label>Responsável</Form.Label>
                  <div className="row pl-3 pr-3">
                    <Form.Control
                    as='select'
                    disabled={disabledSaveUser()}
                    value={user}
                    onChange={e=>setUser(e.target.value)}
                    className="col">
                    <option value=''>---</option>
                    {userList.map(user=>{
                      return <option value={user.value}>{user.label}</option>
                    })}
                    </Form.Control>
                    {user!==defaultUser?(
                      <Button className="col-3 ml-3" onClick={e=>salvarUser(e)}>Salvar</Button>
                    ):''}
                  </div>
                </Form.Group>
              </Col>
              {getMoreFields()}
            </Row>
            {comprovations.length !== 0 ? <Comprovations data={data} /> : ''}
            <Row className="mt-4">
              <Col>
                <h5>{t('title:proof actions')}</h5>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <FileUploadMultiple
                  required
                  files={files}
                  setFiles={files => setFiles(files)}
                  filesComments={filesComments}
                  setFilesComments={filesComments =>
                    setFilesComments(filesComments)
                  }
                  existingFiles={[]}
                  disabled={disabled()}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:additional information')}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows="4"
                    required
                    value={observation}
                    onChange={e => setObservation(e.target.value)}
                    disabled={disabled()}
                  />
                </Form.Group>
              </Col>
            </Row>
            {!load && !isFinished() ? (
              <Row>
                {loading ? (<>
                  <Spinner animation="border" style={{ color: '#e05c17' }} />
                  <h6 className="m-2">Salvando...</h6>
                </>) : (<>                    
                  {renderSendArtsApprovationBtn()}                    
                  {renderRefuseBtn()}
                </>)}
                  {renderApprovedBroadcastingBtn()}
                  {isApprovedBroadcasting() ? (
                    <Button
                      size="sm"
                      variant="dark"
                      className="ml-2"
                      onClick={handleExecute}
                    >
                      {'Executar'}
                    </Button>
                  ) : (<></>)}
              </Row>
            ) : (<></>)}
          </Card.Body>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = state => ({loading: state.loading});

const mapDispatchToProps = dispatch => ({
  saveComprovationCreative: payload => {
    dispatch({ type: ASYNC_CREATE_COMPROVATION, payload });
  }
});

const connectRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardCreativeForm);

export default MasterPage(connectRedux);